import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import classNames from 'classnames';
import { Grid } from "@mui/material";
import _ from "lodash";
import React, {useCallback, useMemo} from "react";
import CompanyEditField from "./CompanyEditField";
import {additionalInfoFieldsArray} from "../company/config";

const CompanyAdditionalInfoForm = ({ isCreate, canEdit, model, errors, onFieldChange, onFieldSave}) => {
    const { t } = useTranslation('CompanyCreateScreen', { keyPrefix: 'AdditionalInfoForm' });
    const [currentEdit, setCurrentEdit] = React.useState('');

    const checkIfDisabled = useCallback((field) => {
        return !isCreate && (!canEdit || field !== currentEdit);
    }, [isCreate, canEdit, currentEdit]);
    
    const getErrorMessage = (field) => _.find(errors, (error) => error.field === field);
    const handleFieldChange = (field, value) => onFieldChange(field, value);
    const handleFieldSave = (field, value) => {
        onFieldSave(field, value);
        setCurrentEdit(null);
    }

    return (
        <div className={classNames('fk-form-section', {'edit-mode': canEdit})}>
            <h3 className="title">{t('title')}</h3>
            <Grid container spacing={2}>
                {additionalInfoFieldsArray.map(({name, modelName, required, items, textarea}, index) => (
                        <CompanyEditField
                            key={index}
                            name={name}
                            multiline={!!textarea}
                            rows={4}
                            model={model}
                            modelName={modelName}
                            required={required}
                            items={items}
                            onChange={handleFieldChange}
                            onEditClick={setCurrentEdit}
                            onSaveClick={handleFieldSave}
                            disabled={checkIfDisabled(name)}
                            canEdit={canEdit}
                            errorMessage={getErrorMessage(name)}
                            currentEdit={currentEdit}
                            t={t}
                            value={model ? model[name] ?? '' : !!items ? '' : ''}
                        />
                ))}
            </Grid>
        </div>
    );
};

const mapStateToProps = (state) => ({
    errors: state.companies.errors,
});

export default connect(mapStateToProps)(CompanyAdditionalInfoForm);